import { PatientCase } from '@/utils/types/zod/patientCaseSchema';

export type CaseMap = Record<string, PatientCase>;

export enum MeetingTypes {
  LIVE = 'live',
  ONLINE = 'online',
  MASTERCLASS = 'masterclass',
}
